import { useAuth0 } from "@auth0/auth0-react";


import Button from "components/button/Button";
import InfoTooltip from "components/InfoTooltip";
import { useFormik } from "formik";
import { useSearch } from "hook";
import AuthService from "Lib/API/Auth";
import FinanceService from "Lib/API/Finance";
import FinanceSettingService from "Lib/API/FinanceSetting/FinanceSetting";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { toastr } from "react-redux-toastr";
import { useHistory } from "react-router-dom";
import Select, { components } from "react-select";
import { colors } from "theme";
import { getOrganizationInfoFromLocalStorage } from "utils/functions";
import BottomArrowSvg from "../../../../../src/assets/icons/svg/BottomArrowSvg";
import {
  InputField,
  RadioButton,
  SelectField,
} from "../../../../components";
import NotAuthorized from "../../../../components/NotAuthorized";
import CheckValidationSchema from "../../../Settings/validationSchema";
import SettingHeader from "../../SettingHeader/settingHEader";
import "./index.scss";
const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <BottomArrowSvg label="Emoji" />
    </components.DropdownIndicator>
  );
};


const styles = {
  circleButtonBody: {
    background: "#FFFFFF",
    borderRadius: "50%",
    width: 20,
    height: 20,
    right: 0,
    top: 3,
    cursor: "pointer",
  },
  textIconButton: {
    color: colors.primaryColor,
    fontSize: 17,
    fontWeight: "bolder",
  },
};
const QuickbooksInformation = ({ heading }) => {
  const history = useHistory();
  const [userInfo, setUserInfo] = useState();
  const [IsSettingsActive, setIsSettingsActive] = useState(true);
  const orgDetails = getOrganizationInfoFromLocalStorage();
  const [type, setType] = useState(false);
  const [open, setOpen] = useState(false);
  const { getAccessTokenSilently } = useAuth0();
  const [getInitialValues, setInitialValues] = useState("");
  const [card, setCard] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [addNew, setAddNew] = useState(false);
  const [updateData, setUpdateData] = useState(true);
  const data = () => {
    setUpdateData(true);
  };
  useEffect(() => {
    async function fetchMyAPI() {
      const token = await getAccessTokenSilently();
      AuthService.getUserExist(token)
        .then((res) => {
          localStorage.setItem(
            "organization",
            JSON.stringify(res?.user?.permissions?.organization)
          );
          localStorage.setItem(
            "authorizedModules",
            JSON.stringify(res?.user?.permissions?.authorizedModules)
          );
          setUserInfo(res);
          setUpdateData(false);
        })
        .catch((err) => {
          setUserInfo(err);
        });
    }
    fetchMyAPI();
  }, [getAccessTokenSilently, updateData, refresh]);

  const radioList = [
    { name: "Quickbooks Online", value: "online" },
    { name: "Quickbooks Desktop", value: "offline" },
    { name: "Sage", value: "sage" },
    { name: "Disable", value: "disable" },
  ];

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      customer_name:
        userInfo?.user?.permissions?.organization?.quickBooks_information
          ?.customer_name,
      customer_id:
        userInfo?.user?.permissions?.organization?.quickBooks_information
          ?.customer_id,
      account_type:
        userInfo?.user?.permissions?.organization?.quickBooks_information
          ?.accountType === "cash"
          ? "Cash"
          : "Accrual",

      program:
        userInfo?.user?.permissions?.organization?.quickBooks_information
          ?.program,
      // realm_id:
      //   userInfo?.user?.permissions?.organization?.quickBooks_information
      //     ?.realm_id,
    },

    onSubmit: async (values) => {
      if(!values?.customer_name) {
        return toastr.info("Validation", "Please enter customer name");
      }
      if(!values?.customer_id) {
        return toastr.info("Validation", "Please enter customer id");
      }
      setInitialValues(values);
      const token = await getAccessTokenSilently();
      let input = {
            org_Id: orgDetails?._id,
            quickBooks_information: {
              customer_name: values?.customer_name,
              customer_id: values?.customer_id,
              accountType:
                values?.account_type === "Cash" ? "cash" : "accrual",

              program: values?.program,
            },
          }
      await AuthService.updateOrgSettings(orgDetails?._id, input, token)
        .then((res) => {
          data();
          setRefresh(!refresh);
          // window.location.href = "/settings";
          toastr.success("Success", "Updated successfully");
          window.dispatchEvent(new CustomEvent("logoImg"));
        })
        .catch((error) => {
          toastr.error("Update Error", error?.data?.message ?? "Some fields are missing");
        });
    },
  });
  const documentTitle = (title) => {
    document.title = title;
  };
  useEffect(() => {
    documentTitle(orgDetails?.orgName);
  }, [orgDetails?.orgName]);

  const handleClick = (e) => {
    const { value, name } = e.target;
    console.log(value, name, "jsakjh");
    if (value) {
      return formik.setFieldValue("program", value);
    }
  };

  let orgInfo =
    localStorage.getItem("authorizedModules") !== undefined
      ? JSON.parse(localStorage.getItem("authorizedModules"))
      : [];

  useEffect(() => {
    let check = orgInfo?.map((item) => {
      if (item?.moduleName == "financial setting") {
        return setIsSettingsActive(item?.active);
      }
    });
  }, []);

  const localStorageData = localStorage.getItem("organization")
    ? JSON.parse(localStorage.getItem("organization"))
    : null;
  const [search, setSearch] = useState("");
  const [loading, setLoading] = React.useState(false);

  const { searchAction } = useSearch({ action: setSearch });

  const [bol, setBol] = useState(1);
  const [queryResponse, setQueryResponse] = useState([]);
  const [selectedQuery, setSelectedQuery] = useState({
    Id: "",
    Name: "",
  });

  useEffect(() => {
    if (userInfo?.user?.permissions?.organization?.quickBooks_information) {
      setSelectedQuery({
        Id:
          userInfo?.user?.permissions?.organization?.quickBooks_information
            ?.customer_id ?? "",
        Name:
          userInfo?.user?.permissions?.organization?.quickBooks_information
            ?.customer_name ?? "",
      });
    }
  }, [userInfo]);

  useEffect(() => {
    if (
      (formik.values?.program === "online" ||
        localStorageData?.quickBooks_information?.program === "online") &&
      bol === 1
    ) {
      // getAccountListForQB();
      getQuickBooksURL();
      setBol(2);
    }
  }, [localStorageData, formik.values?.program]);

  const [check, setCheck] = useState(false);

  const handleQueryArray = (value) => {
    console.log(value, "kjsa");
    setSelectedQuery({
      Id: value.value,
      Name: value.label,
    });
    formik.setFieldValue(`customer_name`, value.label);
    formik.setFieldValue(`customer_id`, value.value);
  };

  const getQuickBooksURL = async (row) => {
    const token = await getAccessTokenSilently();
    await FinanceService.GetDepositQuickbooks(token).then((res) => {
      if (res?.result?.authenticated === true) {
        getAccountListForQB();
      } else {
        window.open(
          res?.result?.url,
          "_blank",
          "toolbar=0,location=0,menubar=0"
        );
        // setCheck(true);
        setQueryResponse([]);
        // history.push("/financial-setting");
      }
    });
  };

  const getAccountListForQB = async () => {
    const token = await getAccessTokenSilently();
    await FinanceSettingService.GetCustomers(token)
      .then((res) => {
        console.log(res);
        const data = res?.result?.QueryResponse?.Customer?.map(
          (item, index) => ({
            value: item?.Id,
            label: item?.DisplayName,
          })
        );
        setQueryResponse(data);
      })
      .catch((e) => {
        toastr.error(e?.data?.message ?? "Error");
      });
  };

  const formatOptionLabel = ({ label, _id }) => {
    return (
      <div className="dropdown-container" key={_id}>
        <div className="icon-name-container d-flex align-items-center justify-content-start">
          <div className="name-container" style={{ marginInlineStart: 10 }}>
            <div>{label}</div>
          </div>
        </div>
      </div>
    );
  };
  const selectControlStyles = {
    backgroundColor: "#F3F6F9",
    borderColor: "#F3F6F9",
    color: "#3F4254",
    transition:
      "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
    paddingTop: "6px",
    paddingBottom: "6px",
    cursor: "pointer",
  };

  const colourStyles = {
    control: (styles) => ({
      ...styles,
      ...selectControlStyles,
    }),
  };

  return IsSettingsActive == false ? (
    <NotAuthorized title={"Quick Books"} />
  ) : (
    <>
      <div className="w-100">
        <SettingHeader
          heading={heading}
          path={"/financial-setting/provider-info/view"}
          edit={false}
          addNew={false}
          setAddNew={setAddNew}
          parentHeading={"Financial"}
          alertOnEdit={false}
        />
        <div className="profile-container provider-Information pt-1">
          <div className="edit-profile-container ">
            <div className="profile-body finance-provider-info">
              <div className="container">
                {/* <Row>
                  <Col className="col-sm-2 d-flex align-items-center">
                    <div className="form-name mt-0">Realm id</div>
                  </Col>
                  <Col className="col-sm-3">
                    <InputField
                      mandatory={false}
                      type="text"
                      {...{
                        formik,
                        name: "realm_id",
                        placeholder: "Realm Id",
                        checkValidation: true,
                        value: formik?.values?.realm_id,
                      }}
                    />
                  </Col>
                </Row> */}
                {console.log(
                  formik.values?.program,
                  "formik.values?.program?.value"
                )}
                <Row>
                  <Col className="col-sm-2 d-flex align-items-center">
                    <div className="form-name mt-0">Customer Name</div>
                    <InfoTooltip text="When QuickBooks Online is connected, click the link to look up and link an existing QuickBooks customer instead of typing one in." style={{ marginLeft: '6px' }} />
                  </Col>
                  <Col className="col-sm-3 mt-2">
                    {queryResponse?.length > 0 &&
                      formik.values?.program === "online" && (
                        <>
                          {/* <LabelField title={"Customer Name"} /> */}

                          <Select
                            {...{
                              formik,
                              name: `account_receivable`,
                              checkValidation: false,
                            }}
                            onInputChange={(text) => searchAction(text)}
                            classNamePrefix="react-select"
                            formatOptionLabel={formatOptionLabel}
                            options={queryResponse}
                            isLoading={loading}
                            styles={colourStyles}
                            onChange={(value) => handleQueryArray(value)}
                            value={
                              selectedQuery
                                ? {
                                  label: selectedQuery?.Name,
                                  value: selectedQuery?.Id,
                                }
                                : ""
                            }
                            components={{ DropdownIndicator }}
                            isDisabled={false}
                          />
                        </>
                      )}
                    {formik.values?.program === "online" &&
                      queryResponse?.length === 0 && (
                        <div
                          className="queryLoad"
                          onClick={() => getQuickBooksURL()}
                        >
                          Click here to get the list
                        </div>
                      )}
                    {formik.values?.program !== "online" && (
                      <div>
                        <InputField
                          mandatory={false}
                          type="text"
                          {...{
                            formik,
                            name: "customer_name",
                            placeholder: "Customer Name",
                            checkValidation: true,
                            value: formik?.values?.customer_name,
                          }}
                        />
                      </div>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col className="col-sm-2 d-flex align-items-center">
                    <div className="form-name mt-0">Customer Id</div>
                  </Col>
                  <Col className="col-sm-3">
                    <InputField
                      mandatory={false}
                      type="text"
                      {...{
                        formik,
                        name: "customer_id",
                        placeholder: "Customer Id",
                        checkValidation: true,
                        value: formik?.values?.customer_id,
                        disabled:
                          formik.values?.program === "online" ? true : false,
                      }}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col className="col-sm-2 d-flex align-items-center">
                    <div className="form-name mt-0">Account Type</div>
                    <InfoTooltip text="Cash or Accrual accounting method. This determines how transactions synced to your accounting software are booked." style={{ marginLeft: '6px' }} />
                  </Col>
                  <Col className="col-sm-3">
                    <SelectField
                      {...{
                        formik,
                        title: "",
                        name: "account_type",
                        mandatory: false,
                        items: ["Accrual", "Cash"],
                        value:
                          formik.values.account_type ??
                          "Select Account Type...",
                        placeholder: "Select Account Type...",
                      }}
                      onClick={(v) => {
                        formik.setFieldValue("account_type", v);
                      }}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col className="col-sm-2 d-flex align-items-center">
                    <div className="form-name mt-0">Accounting software</div>
                    <InfoTooltip placement="bottom" text="Choosing QuickBooks Online, QuickBooks Desktop, or Sage adds a matching account picker to Ledger Accounts, Bank Accounts, and Accounts Receivable elsewhere in Financial settings, so they can sync with it." style={{ marginLeft: '6px' }} />
                  </Col>
                  <Col className="col-sm-10 d-flex align-items-center">
                <div className="form-group provider-radio-buttn quick-book-radio">
                  <RadioButton
                    title=""
                    list={radioList}
                    {...{
                      formik,
                      name: "program",
                    }}
                    onClick={(e) => {
                      handleClick(e);
                      setBol(1);
                    }}
                    boxValue={formik.values?.program}
                    elementStyle={{
                      width: "auto",
                    }}
                  />
                </div>
                </Col>
                </Row>
                {/* <Row>
                  <Col className="col-sm-2 d-flex align-items-center">
                    <div className="form-name mt-0">Client Id</div>
                  </Col>
                  <Col className="col-sm-3">
                    <InputField
                      mandatory={false}
                      type="text"
                      {...{
                        formik,
                        name: "client_id",
                        placeholder: "Client Id",
                        checkValidation: true,
                        value: formik?.values?.client_id,
                      }}
                    />
                  </Col>
                </Row>
                <Row className="address-field-height">
                  <Col className="col-sm-2">
                    <div className="form-name">Client Secret</div>
                  </Col>
                  <Col className="col-sm-3">
                    <InputField
                      type="text"
                      mandatory={false}
                      {...{
                        formik,
                        name: "client_secret",
                        placeholder: "Client Secret",
                        checkValidation: true,
                        value: formik?.values?.client_secret,
                      }}
                    />
                  </Col>
                </Row> */}
              </div>
            </div>
          </div>
        <div className="page-footer d-flex justify-content-start  mt-5 container">
          <div className="">
          <Button
              type="button"
              onClick={() => {
                formik.handleSubmit();
              }}
              variant="primary"
              size="md"
              style={{ minWidth: 80 }}
            >
              Save
            </Button>
          </div>
        </div>
        </div>
      </div>
    </>
  );
};

export default QuickbooksInformation;
